export default {
  admin: () => import("/codebuild/output/src2814414732/src/sense-us.app/layouts/admin.vue").then(m => m.default || m),
  auth: () => import("/codebuild/output/src2814414732/src/sense-us.app/layouts/auth.vue").then(m => m.default || m),
  none: () => import("/codebuild/output/src2814414732/src/sense-us.app/layouts/none.vue").then(m => m.default || m),
  public: () => import("/codebuild/output/src2814414732/src/sense-us.app/layouts/public.vue").then(m => m.default || m)
}